import MiniSelect from "@/components/storyboard/MiniSelect";
import { Textarea } from "@/components/ui/textarea";
import { SHOT_TYPES, CAMERA_MOVEMENTS, LENS_OPTIONS, LIGHTING_STYLES } from "@/constants/shotSettings";
import { ChevronUp, ChevronDown, X, Monitor, Film } from "lucide-react";

/** One editable proposed micro-insert in the expansion review strip. */
export default function ProposalCard({ proposal, index, total, onChange, onDelete, onMove }) {
  const isScreen = proposal.render_kind === "screen_capture";
  const set = (field) => (value) => onChange({ ...proposal, [field]: value });

  return (
    <div className="rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-muted)] p-2.5">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[11px] font-semibold text-[var(--text-muted)] w-10">#{index + 1}</span>
        <button
          onClick={() => onChange({ ...proposal, render_kind: isScreen ? "photoreal" : "screen_capture" })}
          className={`text-[11px] px-1.5 py-0.5 rounded border flex items-center gap-1 ${
            isScreen ? "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" : "bg-[var(--bg-elevated)] text-[var(--text-muted)] border-[var(--border-subtle)]"
          }`}
        >
          {isScreen ? <Monitor size={10} /> : <Film size={10} />}{isScreen ? "Screen" : "Photoreal"}
        </button>
        <div className="flex-1" />
        <button disabled={index === 0} onClick={() => onMove(index, index - 1)} className="p-1 disabled:opacity-30 hover:text-[var(--text-primary)] text-[var(--text-muted)]"><ChevronUp size={13} /></button>
        <button disabled={index === total - 1} onClick={() => onMove(index, index + 1)} className="p-1 disabled:opacity-30 hover:text-[var(--text-primary)] text-[var(--text-muted)]"><ChevronDown size={13} /></button>
        <button onClick={() => onDelete(index)} className="p-1 text-[var(--text-muted)] hover:text-red-400"><X size={13} /></button>
      </div>

      <Textarea
        value={proposal.whats_in_frame || ""}
        onChange={(e) => onChange({ ...proposal, whats_in_frame: e.target.value, prompt: e.target.value })}
        className="text-[11px] min-h-[44px] bg-[var(--bg-elevated)] border-[var(--border-subtle)] mb-2"
        placeholder="What's in this insert…"
      />

      <div className="grid grid-cols-4 gap-1.5">
        <MiniSelect options={SHOT_TYPES} value={proposal.shot_type} onChange={set("shot_type")} label="shot" />
        <MiniSelect options={CAMERA_MOVEMENTS} value={proposal.camera_movement} onChange={set("camera_movement")} label="move" />
        <div className={isScreen ? "opacity-40 pointer-events-none" : ""}>
          <MiniSelect options={LENS_OPTIONS} value={proposal.lens} onChange={set("lens")} label="lens" />
        </div>
        <div className={isScreen ? "opacity-40 pointer-events-none" : ""}>
          <MiniSelect options={LIGHTING_STYLES} value={proposal.lighting} onChange={set("lighting")} label="light" />
        </div>
      </div>
    </div>
  );
}
